import { Checkbox, Select } from "antd";
import { useState } from "react";
import toast from "react-hot-toast";
import {
  BiLocationPlus,
  BiSolidBuilding,
  BiSolidFlag,
  BiSolidPhoneCall,
  BiSolidUserCircle,
  BiSolidZap
} from "react-icons/bi";
import { IoCloseSharp } from "react-icons/io5";
import { PhoneInput } from "react-international-phone";
import { useSelector } from "react-redux";
import { Col, Label, Modal, ModalBody, Row } from "reactstrap";
import { checkVendorDomainAPI } from "../../api/pagination";
import { orderTerms, statesArray } from "../../data";
import {
  generateCustomID,
  saveData,
  uniqueID
} from "../../firebase/utility";
import GeneralButton from "../button/GeneralButton";
import FormInput from "../formInput/FormInput";
const AddNewVendorDetails = ({
  modal,
  toggle,
  data,
  setData,
  gettingVendors,
}) => {

  const [loading, setLoading] = useState(false);
  const [billing, setBilling] = useState({
    first_name: "",
    last_name: "",
    phone: "",
    email: "",
    company: "",
    address_1: "",
    address_2: "",
    city: "",
    state: "",
    country: "",
    postcode: "",
    order_return_status: "",
    order_sms: "",
    website: "",
    blind_dropship: false,
    dba: [],
  });
  const resetForm = () => {
    setBilling({
      first_name: "",
      last_name: "",
      phone: "",
      email: "",
      company: "",
      address_1: "",
      address_2: "",
      city: "",
      state: "",
      country: "",
      postcode: "",
      order_return_status: "",
      order_sms: "",
      website: "",
      blind_dropship: false,
      dba: [],
    });
  };
  const handleSave = () => {
    setLoading(true);
    if (
      billing?.first_name === "" ||
      billing?.last_name === "" ||
      billing?.phone === "" ||
      billing?.email === "" ||
      billing?.address_1 === "" ||
      billing?.city === "" ||
      billing?.country === "" ||
      billing?.state === "" ||
      billing?.postcode === "" ||
      billing?.terms === ""
    ) {
      toast.error("Please fill all required fields ");
      setLoading(false);
      return;
    }

    checkVendorDomainAPI(billing?.email, "", (response) => {
      if (response?.status !== 200) {
        toast.error(response?.message);
        setLoading(false);
        setData([]);
        toggle();
        return;
      } else {
        generateCustomID("Vendors", "id").then((res) => {
          if (res) {
            let obj = {
              billing: [billing],
              _id: uniqueID(),
              first_name: billing?.first_name,
              last_name: billing?.last_name,
              id: res,
              createdAt: Date.parse(new Date()),
            };
            saveData("Vendors", obj?._id, obj).then((res) => {
              toast.success(`Vendor ${obj?.id} Created Successfully`);
              gettingVendors();
              setLoading(false);
              setData([]);
              toggle();
            });
          }
        });
      }
    });
  };
  return (
    <div>
      <Modal
        isOpen={modal}
        toggle={toggle}
        centered
        size="xl"
        onClosed={resetForm}
      >
        <ModalBody className="p-0 border-0">
          <div className="d-flex mb-1 justify-content-between align-items-center p-4 border-bottom bg-light rounded-top">
            <h5 className="fw-bold text-dark mb-0 d-flex align-items-center gap-2">
              <BiLocationPlus className="text-primary mr-2" /> Add Vendor Details
            </h5>
            <IoCloseSharp size={24} className="text-muted pointer hover-opacity-75" onClick={toggle} style={{ cursor: "pointer" }} />
          </div>
          <Row className="mb-0  p-3 ">
            <Col md={4}>
              <FormInput
                type={"text"}
                label={"First Name "}
                placeholder={"First Name"}
                // className={`sales__inputCustomer }`}
                icon={<BiSolidUserCircle size={20} color="#B0B0B0" />}
                value={billing?.first_name}
                handleChange={(e) =>
                  setBilling({
                    ...billing,
                    first_name: e.target.value,
                  })
                }
              />
            </Col>
            <Col md={4}>
              <FormInput
                type={"text"}
                label={"Last Name "}
                placeholder={"Last Name"}
                // className={`sales__inputCustomer }`}
                icon={<BiSolidUserCircle size={20} color="#B0B0B0" />}
                value={billing.last_name}
                handleChange={(e) =>
                  setBilling({
                    ...billing,
                    last_name: e.target.value,
                  })
                }
              />
            </Col>
            <Col md={4}>
              <Label className="fw-bold">Phone</Label>
              <PhoneInput
                placeholder="Enter phone number"
                value={billing.phone}
                style={{ width: "100%" }}
                onChange={(e) =>
                  setBilling({
                    ...billing,
                    phone: e,
                  })
                }
              />
            </Col>
            <Col md={4}>
              <FormInput
                type={"text"}
                label={"Email"}
                placeholder={"Email"}
                icon={<BiSolidPhoneCall size={20} color="#B0B0B0" />}
                value={billing.email}
                handleChange={(e) => {
                  let val = e.target.value;
                  setBilling({
                    ...billing,
                    email: val?.trim(),
                  });
                }}
              />
            </Col>
            <Col md={4}>
              <FormInput
                type={"text"}
                label={"Company Name"}
                placeholder={"Company name"}
                icon={
                  <BiSolidBuilding size={"20"} style={{ color: "#B0B0B0" }} />
                }
                value={billing.company}
                handleChange={(e) =>
                  setBilling({
                    ...billing,
                    company: e.target.value,
                  })
                }
              />
            </Col>
            <Col md={4}>
              <FormInput
                type={"text"}
                label={"Website"}
                placeholder={"Website"}
                icon={
                  <BiSolidBuilding size={"20"} style={{ color: "#B0B0B0" }} />
                }
                value={billing.website}
                handleChange={(e) =>
                  setBilling({
                    ...billing,
                    website: e.target.value,
                  })
                }
              />
            </Col>
            <Col md={6}>
              <FormInput
                type={"text"}
                label={"Address Line 1"}
                placeholder={"Enter Billing Address"}
                icon={
                  <BiLocationPlus size={"20"} style={{ color: "#B0B0B0" }} />
                }
                value={billing.address_1}
                handleChange={(e) =>
                  setBilling({
                    ...billing,
                    address_1: e.target.value,
                  })
                }
              />
            </Col>
            <Col md={6}>
              <FormInput
                type={"text"}
                label={"Address Line 2"}
                placeholder={"Enter Billing Address"}
                icon={
                  <BiLocationPlus size={"20"} style={{ color: "#B0B0B0" }} />
                }
                value={billing.address_2}
                handleChange={(e) =>
                  setBilling({
                    ...billing,
                    address_2: e.target.value,
                  })
                }
              />
            </Col>
            <Col md={3}>
              <FormInput
                type={"text"}
                label={"Country"}
                placeholder={"Country"}
                icon={<BiSolidFlag size={"20"} style={{ color: "#B0B0B0" }} />}
                value={billing.country}
                handleChange={(e) =>
                  setBilling({
                    ...billing,
                    country: e.target.value,
                  })
                }
              />
            </Col>
            <Col md={3}>
              <FormInput
                dropdown
                type={"select"}
                label={"State"}
                placeholder={"Enter State"}
                className={`  border border-1 h-50 rounded-3`}
                options={statesArray}
                showSearch={true}
                value={billing?.state}
                handleChange={(value) => {
                  setBilling({
                    ...billing,
                    state: value,
                  });
                }}
                icon={<BiSolidFlag size={"20"} style={{ color: "#B0B0B0" }} />}
              />
            </Col>
            <Col md={3}>
              <FormInput
                type={"text"}
                label={"City"}
                placeholder={"City"}
                icon={<BiSolidFlag size={"20"} style={{ color: "#B0B0B0" }} />}
                value={billing.city}
                handleChange={(e) =>
                  setBilling({
                    ...billing,
                    city: e.target.value,
                  })
                }
              />
            </Col>
            <Col md={3}>
              <FormInput
                type={"text"}
                label={"Zip Code"}
                placeholder={"Enter Zip Code"}
                icon={<BiSolidZap size={"20"} style={{ color: "#B0B0B0" }} />}
                value={billing.postcode}
                handleChange={(e) =>
                  setBilling({
                    ...billing,
                    postcode: e.target.value,
                  })
                }
              />
            </Col>
            <Row className="mb-3 d-flex align-items-end">
              <Col md={3}>
                <FormInput
                  dropdown
                  type={"select"}
                  label={"Payment Terms *"}
                  placeholder={"Enter State"}
                  className={`  border border-1 h-50 rounded-3`}
                  options={orderTerms?.map((i) => ({ label: i.label, value: i.value }))}
                  handleChange={(e, value) => {
                    setBilling({
                      ...billing,
                      terms: e,
                    });
                  }}
                  icon={
                    <BiSolidFlag size={"20"} style={{ color: "#B0B0B0" }} />
                  }
                />
              </Col>
              <Col md={4}>
                <Checkbox
                  checked={billing?.blind_dropship}
                  onChange={(e) =>
                    setBilling({
                      ...billing,
                      blind_dropship: e.target.checked,
                    })
                  }
                >
                  Blind Dropship
                </Checkbox>
              </Col>
            </Row>
            <div className="d-flex justify-content-end">
              <GeneralButton
                title={"Cancel"}
                className={"white-button mx-2"}
                width={"180px"}
                handleClick={() => {
                  toggle();
                  setBilling({});
                }}
              />
              <GeneralButton
                title={"Save"}
                className={"blue-button"}
                width={"180px"}
                loading={loading}
                disabled={loading}
                handleClick={handleSave}
              />
            </div>
          </Row>
        </ModalBody>
      </Modal>
    </div>
  );
};
export default AddNewVendorDetails;
